import Immutable from 'seamless-immutable';
import { AnyAction } from 'redux';
import { NETWORK_DISCONNECTED, NETWORK_CONNECTED } from 'actions/network';

const INITIAL_STATE = Immutable({
  networkConnected: true,
  previouslyConnected: true,
});

export default (state = INITIAL_STATE, action: AnyAction) => {
  switch (action.type) {
    case NETWORK_DISCONNECTED:
      return state.merge({
        networkConnected: false,
        previouslyConnected: state.networkConnected,
      });
    case NETWORK_CONNECTED:
      return state.merge({
        networkConnected: true,
        previouslyConnected: state.networkConnected,
      });
    default:
      return state;
  }
};
